<template>
  <div>
    <vxe-modal ref="modal" v-model="formVisible" title="选择合同模板" width="80%" height="90%">
      <div class="select-panel">
        <div class="select-table">
          <vxe-grid
            ref="xTable"
            resizable
            :column-config="{ minWidth: '80px' }"
            :data="tableData"
            :showOverflow="true"
            size="mini"
            :mouse-config="{ area: true }"
            :tooltip-config="{
              showAll: true,
              theme: 'dark'
            }"
            :pager-config="tablePage"
            @page-change="handlePageChange"
            :seq-config="{
              startIndex: (tablePage.currentPage - 1) * tablePage.pageSize
            }"
            highlight-hover-row
            highlight-current-row
            height="100%"
            :columns="gridColumns"
            :keyboard-config="{
              isArrow: true,
              isEnter: true,
              isTab: true,
              isClip: true,
              enterToTab: true,
              isEdit: true
            }"
            :scroll-y="{
              mode: 'wheel'
            }"
          >
          </vxe-grid>
        </div>

        <!-- 页脚按钮 -->
        <div class="operate-area">
          <el-button type="primary" @click="handleSelect">选择</el-button>
          <el-button type="danger" @click="formVisible = false">取消</el-button>
        </div>
      </div>
    </vxe-modal>
  </div>
</template>

<script>
export default {
  name: 'ContractTempSelect',
  data() {
    return {
      formVisible: false,
      gridColumns: [
        { type: 'seq', width: 40, fixed: 'left' },
        { type: 'checkbox', width: 40, fixed: 'left' },
        {
          field: 'contract_template_name',
          title: '标题'
        },
        {
          field: 'creator',
          title: '创建者'
        },
        {
          field: 'createTime',
          title: '创建时间',
          formatter: ['formatDate', 'yyyy-MM-dd HH:mm:ss']
        },
        {
          field: 'last_modify_time',
          title: '最后更新时间',
          formatter: ['formatDate', 'yyyy-MM-dd HH:mm:ss']
        }
      ],
      tableData: [],
      // 查询条件
      searchObjects: [],
      // 获取权限
      Authority: this.AuthorityFilter(this.$route.path),
      // 分页设置
      tablePage: {
        total: 0,
        currentPage: 1,
        pageSize: this.tablePageConfig.defaultPageSize,
        align: 'right',
        pageSizes: this.tablePageConfig.pageSizes,
        layouts: ['Sizes', 'PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'FullJump', 'Total'],
        perfect: true
      }
    }
  },
  methods: {
    openModal() {
      this.formVisible = true
      this.list()
    },
    handleSelect() {
      const records = this.$refs.xTable.getCheckboxRecords()
      if (records.length === 0) {
        this.$message.warning('请选择合同模板')
        return
      }
      const record = records[0]
      this.$emit('sure', record)
      this.formVisible = false
    },
    // 切换查询面板可见性
    handlePageChange({ currentPage, pageSize }) {
      this.tablePage.currentPage = currentPage
      this.tablePage.pageSize = pageSize
    },
    async list() {
      const { data: res } = await this.$http.post('/Finance/Contract/Template/list', {
        pageIndex: this.tablePage.currentPage,
        pageSize: this.tablePage.pageSize,
        seeType: this.Authority.seeType,
        searchObjects: this.searchObjects,
        sqlTitle: 'APPROVE'
      })
      if (res.isSuccess) {
        this.tableData = res.data.rows
        this.tablePage.total = res.data.totals
      } else {
        this.$message.error(res.errorMessage)
        return false
      }
    }
  }
}
</script>

<style scoped lang="less">
.operate-area {
  display: flex;
  align-items: center;
  justify-content: center;
}
.select-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.select-table {
  height: 100%;
}
</style>
